<template>
  <b-modal
    :visible="visible"
    centered
    modal-class="status-update-modal sales_sts_update_sp"
    no-close-on-backdrop
    title="Change Assigned Agent"
    @change="val => $emit('update:visible', val)"
  >
    <p class="mb-2">
      Assign a different agent to this Sales Order
    </p>

    <b-form-group label="Agent Name">
      <b-input-group>
        <b-form-input
          v-model="query"
          placeholder="Search Agent or Probationary Agent Name, or Code"
          autocomplete="off"
          @input="onQueryInput"
          @focusout="hideResultsDelayed"
        />
      </b-input-group>
      <div
        v-show="showResults"
        class="search-results mt-50 z-index-99"
      >
        <b-list-group
          v-if="results.length"
          flush
        >
          <b-list-group-item
            v-for="agent in results"
            :key="agent._id"
            class="cursor-pointer"
            @click="selectAgent(agent)"
          >
            <span class="text-primary">{{ agent.name }}</span>
            <br>
            <small class="text-muted">{{ agent.code }}</small>
          </b-list-group-item>
        </b-list-group>
        <b-list-group v-else-if="query">
          <b-list-group-item>
            No result found.
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-form-group>

    <div class="service-agent-warning-tittle">
      Warning
    </div>
    <div class="service-agent-warning mb-2">
      This action will require the new agent to contact the customer and request them to re-sign all previously submitted documents. Please confirm before proceeding.
    </div>

    <b-form-checkbox
      v-model="understood"
      class="mb-2"
    >
      I understand that changing the assigned agent will require the new agent to re-obtain customer signatures for all submitted documents.
    </b-form-checkbox>

    <template #modal-footer="{}">
      <b-button
        variant="flat-primary"
        :disabled="saving"
        @click="$emit('update:visible', false)"
      >
        Cancel
      </b-button>
      <b-button
        variant="success-custom"
        type="button"
        :disabled="!canSave || saving"
        @click="save"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Save Changes</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BInputGroup, BFormInput, BFormCheckbox, BButton, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BModal, BFormGroup, BInputGroup, BFormInput, BFormCheckbox, BButton, BListGroup, BListGroupItem,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    // The current sales/service agent's agencyCode - the new agent must come from the same
    // agency, so suggestions are scoped server-side rather than filtered here.
    agencyCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      query: '',
      results: [],
      showResults: false,
      selectedAgent: null,
      understood: false,
      timer: null,
    }
  },
  computed: {
    canSave() {
      return !!this.selectedAgent && this.understood
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.query = ''
        this.results = []
        this.showResults = false
        this.selectedAgent = null
        this.understood = false
      }
    },
  },
  methods: {
    onQueryInput() {
      this.selectedAgent = null
      if (this.timer) clearTimeout(this.timer)
      if (!this.query || this.query.length < 2) {
        this.results = []
        this.showResults = false
        return
      }
      if (!this.agencyCode) {
        this.results = []
        this.showResults = false
        return
      }
      this.timer = setTimeout(() => {
        axios.get('reservation/reservations/respond-with/agents/same-agency', { params: { search: this.query, agencyCode: this.agencyCode } })
          .then(response => {
            // Service Agent is confirmed-Agent-only today - the shared suggestion endpoint also
            // returns Probationary Agents (used elsewhere for the submitting/main agent), so those
            // get filtered out here rather than built into the endpoint itself.
            this.results = (response.data.agents || []).filter(agent => agent.modelType === 'Agent')
            this.showResults = true
          })
      }, 1000)
    },
    hideResultsDelayed() {
      setTimeout(() => {
        this.showResults = false
      }, 200)
    },
    selectAgent(agent) {
      this.selectedAgent = agent
      this.query = agent.name
      this.showResults = false
    },
    save() {
      this.$emit('save', { agentId: this.selectedAgent._id })
    },
  },
}
</script>

<style lang="scss" scoped>
.search-results {
  position: absolute;
  background: #fff;
  border: 1px solid #e0e5eb;
  border-radius: 6px;
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.service-agent-warning {
  background: #fdf1d9;
  color: #7a5a1a;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 13px;
}
</style>
